import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";
import Header from "./Header";
import Footer from "../components/Footer";
import "./style.css";
import "./responsive.css";
import BlogDetailsList from "./BlogDetailsList";

export default function BlogDetails(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 425);
  const navigate = useNavigate();
  const aboutUsRef = useRef(null);
  const feedbackRef = useRef(null);
  const homeRef = useRef(null);

  const scrollToAboutUs = () => {
    if (aboutUsRef.current) {
      aboutUsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToFeedback = () => {
    if (feedbackRef.current) {
      feedbackRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollToHome = () => {
    if (homeRef.current) {
      homeRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    window.addEventListener(
      "resize",
      () => {
        const ismobile = window.innerWidth > 425;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      const targetElement = document.querySelector(hash);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        scrollToAboutUs={scrollToAboutUs}
        fixed
        scrollToHome={scrollToHome}
        scrollToFeedback={scrollToFeedback}
        aboutUsRef={aboutUsRef}
        feedbackRef={feedbackRef}
      />
      <main className="flex-grow">
        <div
          className="w-full px-4 pb-12 pt-20 sm:pb-16 sm:pt-24"
          ref={homeRef}
        >
          <div className="mb-4 flex items-center justify-between">
            <button
              onClick={handleBack}
              className="text-gray-500 hover:text-gray-700 focus:outline-none"
              title="Go Back"
            >
              <FaArrowLeft className="w-6 h-6" />
            </button>
            <h2 className="text-2xl font-bold text-center flex-1">Blog Details</h2>
            <div className="w-6" />
          </div>
          <div className="w-full">
            <BlogDetailsList />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
